import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const termLoansCriteria = [
  ...sharedCriteriaFields({ hasNetProfitPercentage: true }),
  {
    columns: 12,
    fields: [
      {
        optionsColumns: 6,
        field: 'suitableFundingType',
        type: 'multiple',
      },
    ],
    label: 'What type of funding solutions do you offer?',
  },
  {
    fields: [
      {
        optionsColumns: 6,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'useOfFunds',
        optionsColumns: 4,
        type: 'multiple',
      },
    ],
    label: 'For what funding purposes is this product suitable?',
  },
];

export const termLoansFees = sharedFeesFields(false);
